/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'organization-data-concept': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M13.053 12.17a3.725 3.725 0 000-4.34l1.322-1.321.808.808c.244.244.64.244.884 0l2.5-2.5a.625.625 0 000-.884l-2.5-2.5a.625.625 0 00-.884 0l-2.5 2.5a.625.625 0 000 .884l.808.808-1.322 1.322a3.725 3.725 0 00-4.338 0L6.25 5.366V1.25h-5v5h4.116l1.58 1.58a3.725 3.725 0 000 4.34l-1.32 1.32-.808-.808a.625.625 0 00-.884 0l-2.5 2.5a.625.625 0 000 .884l2.5 2.5c.244.244.64.244.884 0l2.5-2.5a.625.625 0 000-.884l-.808-.808 1.322-1.322c1.297.93 3.041.93 4.338 0l1.581 1.581v4.116h5v-5h-4.116l-1.58-1.58zm2.572-9.411l1.616 1.616-1.616 1.616-1.616-1.616 1.616-1.616zM4.375 17.24l-1.616-1.616 1.616-1.616 1.616 1.616-1.616 1.616zM5 5H2.5V2.5H5V5zm2.5 5a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0zm7.5 5h2.5v2.5H15V15z"/>'
  }
})
